
/* Built In Imports */
import { useRouter } from 'next/router';
import { useCallback, useContext, useEffect, useState } from 'react';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import Select from 'react-select';

/* Internal Imports */
/* Components */
import MMMCard from '@components/Card/MMMCard';
import Loader from '@components/Utility/Loader';
import { AuthContext } from '@store/auth-context';

/* Services */
import { fetchSadhguruMMMPosts } from 'services/sadhguruService';

/**
 * 
 * @param posts.posts
 * @param {object} posts - post of section 
 * @param {object} mmmSection - data 
 * @param {object} contentTypes - Content Types in api
 * @param {object} page
 * @param {object} history
 * @returns {ReactElement} - CardFilter Component
 */

const CardFilter = ({ posts, mmmSection, contentTypes, page, history, region, lang }) => {
  const [mmmPosts, setMMMPosts] = useState(posts);
  const [postOffset, setPostOffset] = useState(posts?.length);
  const [postContentType, setPostContentType] = useState('');
  const [hasLoadMore, setHasLoadMore] = useState(posts?.length > 4);
  // const [selectedContentTypeText, setSelectedContentTypeText] = useState('');
  const [selectedMmmSectionText, setSelectedMmmSectionText] = useState('');
  const [selectedMmmSection, setSelectedMmmSection] = useState(mmmSection);
  const [isLoader, setIsLoader] = useState(false);
  // const [selectedTextArr, setSelectedTextArr] = useState([]);
  const authCtx = useContext(AuthContext);
  const router = useRouter();

  const mmmPostFilterHandler = useCallback(
    async event => {
      setIsLoader(true);
      setSelectedMmmSectionText(event.value || '');
      // let enteredValue = event.value;

      let morePosts = [];
      if (page === 'sadhguru' && event.value !== '') {
        morePosts = await fetchSadhguruMMMPosts(
          event.value,
          0,
          '',
          12,
          authCtx?.region,
          authCtx?.lang
        );
        setPostContentType('');
      } else {
        morePosts = await fetchSadhguruMMMPosts(
          mmmSection,
          0,
          event.value,
          12,
          authCtx.region,
          authCtx.lang
        );
        setPostContentType(event.value);
      }

      if (morePosts.length > 0) {
        setIsLoader(false);
      }

      // if (event.value !== '') {
      //   setSelectedContentTypeText(event.text);
      // } else {
      //   setSelectedContentTypeText('');
      // }
      setMMMPosts([...morePosts]);
      setPostOffset(morePosts.length);
      setHasLoadMore(morePosts.length === 12);
      setSelectedMmmSection(event.value);
      // setSelectedTextArr(prevText => {
      //   return [...prevText, event.value];
      // });
    },
    [authCtx.lang, authCtx.region, mmmSection, page]
  );

  useEffect(() => {
    if (page !== 'sadhguru' && authCtx.region && authCtx.lang) {
      mmmPostFilterHandler('');
    }
  }, [router.asPath, authCtx.lang, authCtx.region, page, mmmPostFilterHandler]);

  const loadMoreMMMPosts = async () => {
    setIsLoader(true);
    let morePosts = [];
    if (page === 'sadhguru') {
      morePosts = await fetchSadhguruMMMPosts(
        selectedMmmSection,
        postOffset,
        postContentType,
        8,
        authCtx?.region,
        authCtx?.lang
      );
    } else {
      morePosts = await fetchSadhguruMMMPosts(
        mmmSection,
        postOffset,
        postContentType,
        8,
        authCtx.region,
        authCtx.lang
      );
    }

    if (morePosts.length >= 0) {
      setIsLoader(false);
    }
    setMMMPosts([...mmmPosts, ...morePosts]);
    setPostOffset(prevOffset => prevOffset + morePosts.length);
    setHasLoadMore(morePosts.length === 8);
  };

  // const resetFilter = () => {
  // let select = document.querySelector('#mmm-filter');
  //   select.value = '';
  //   select.dispatchEvent(new Event('change', { bubbles: true }));
  // };

  const options = [
    {
      value: '',
      label: 'View All',
    },
  ];

  if (contentTypes && contentTypes.length) {
    contentTypes.map((contentType) => {
      options.push({
        value: contentType.toLowerCase(),
        label: contentType,
      });
    });
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#ffffff' : '#cf4520',
      '&:hover': {
        color: '#fff',
        cursor: 'pointer',
      },
      fontFamily: 'FedraSansStd-book',
    }),
    control: (provided, state) => ({
      ...provided,
      // border: 0,
      borderBottom: '1px solid #aea493',
      backgroundColor: 'transparent',
      '&:hover': {
        cursor: 'pointer'
      }
    })
  };

  return (
    <>
      <Box
        float="left"
        width="100%"
        padding={{
          base: '0 5px 10px 0',
          sm: '0 5px 10px 0',
          md: '0 16px',
          lg: '0 60px',
        }}
        pos="relative"
      >
        <Box
          m={{ sm: '0', md: '15px', lg: '0 0 5px 0' }}
          float="left"
          width="100%"
        // p={{ base: "0", md: "35px 85px 4px", lg: "20px 40px" }}
        >
          <Box float="left" width="100%">
            <Box
              float="left"
              pb={{ base: '30px', sm: '30px', md: '0', lg: '0' }}
              width={{ base: '100%', sm: '60%' }}
            >
              <Box
                pt={{ sm: '0', md: '10px' }}
                lineHeight={{
                  base: '35px',
                  sm: '35px',
                  md: '20px',
                  lg: '20px',
                }}
                // borderBottom={{ sm: '0' }}
                float="left"
                // width="75px"
                fontFamily="FedraSansStd-medium, sans-serif"
                fontSize="14px"
                textAlign="left"
                color="rgb(138 129 115)"
                pl={{ base: '15px', sm: '15px', md: '0', lg: '0' }}
              >
                FILTERS:
              </Box>
              <Box
                float="left"
                w="150px"
                ml="15px"
                lineHeight="20px"
                fontFamily="'FedraSerifAStdBook',sans-serif"
                fontSize="14px"
              >
                <Select
                  maxWidth="170px"
                  lineHeight="30px"
                  id="mmm-filter"
                  onChange={mmmPostFilterHandler}
                  value={options.find(
                    (obj) => obj.value == selectedMmmSectionText
                  )}
                  styles={customStyles}
                  defaultValue={options[0]}
                  options={options}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                      ...theme.colors,
                      primary25: '#cf4520',
                      primary: '#cf4520',
                    },
                  })}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <MMMCard mmmCardData={mmmPosts} lang={authCtx.lang} region={region} />

        <Box pos="relative" float="left" w="100%">
          {' '}
          {hasLoadMore && (
            <Link
              display="block"
              width="170px"
              p="10px 36px"
              border="none"
              borderRadius="2px"
              bgColor="#cf4520"
              color="#fff"
              fontSize="18px"
              fontFamily="FedraSansStd-A-medium"
              textAlign="center"
              m="0 auto"
              mt="30px"
              _hover={{ textDecoration: 'none' }}
              onClick={loadMoreMMMPosts}
              title="Go to next page"
              rel="next"
            >
              Load More
            </Link>
          )}
        </Box>
        {isLoader && <Loader />}
      </Box>
    </>
  );
};

export default CardFilter;
